import { render } from "./HeaderLanding.vue?vue&type=template&id=362c670a"
import script from "./HeaderLanding.vue?vue&type=script&lang=js"
export * from "./HeaderLanding.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/frontend-dilatih/frontend-dilatih/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__